export const UpdateMaximoLoginStatus = (store, logIn) => {
  store.dispatch({
    type: "installer/updateMaximoLoginStatus",
    payload: {
      status: logIn,
    },
  });
};
